import React from "react";
import {
  Popover,
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { VehicleFilters } from "../../hooks/useVehicleFilters";

type FilterDropdownProps = {
  isOpen: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  filters: VehicleFilters;
  onFilterChange: (key: keyof VehicleFilters, value: number | null) => void;
  passengerCount: number;
};

function FilterDropdown({
  isOpen,
  onClose,
  anchorEl,
  filters,
  onFilterChange,
  passengerCount,
}: FilterDropdownProps) {
  const handleMinCapacityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFilterChange("minCapacity", event.target.checked ? passengerCount : null);
  };

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box p={2} minWidth={250}>
        <Typography variant="subtitle2" color="textSecondary" mb={1}>
          Filter Vehicles
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.minCapacity === passengerCount}
              onChange={handleMinCapacityChange}
              color="primary"
            />
          }
          label={`Min Capacity (${passengerCount} pax)`}
        />
      </Box>
    </Popover>
  );
}

export default FilterDropdown;